import { Chip, Grid } from "@mui/material";
import EditAction from "../components/edit-action/edit-action";
import DeleteAction from "../components/delete-action/delete-action";
import VerifyAccess from "@/common/components/verify-access/verify-access";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { dateString } from "@/common/components/TableView/helpers/helpers";
const {materialTabMasterKey} = requestedMenuAll;
const {updateKey, deleteKey} = requestedFeaturesAll;

export const columns = ({onRowEdit, onRowDelete, deletePrimaryCustomerMasterStatus,
  isUpdateDeleteAccess}) => ([...[
  {
    header: 's-no',
    accessorKey: 'fdMaterialId',
    cell: (value) => {
      const fdMaterialId = value.row.index + 1;
     return fdMaterialId;
    }
  },
  {
    header: 'material-code',
    accessorKey: 'materialCode'
  },
  {
    header: 'material-name',
    accessorKey: 'materialName'
  },
  {
    header: 'category-name',
    hideColumn: false,
    accessorKey: 'categoryName'
  },
  {
    header: 'brand-name',
    hideColumn: false,
    accessorKey: 'brandName'
  },
  {
    header: 'product-name',
    hideColumn: false,
    accessorKey: 'ProductName'
  },
  {
    header: 'conversion-factor',
    hideColumn: false,
    accessorKey: 'conversionFactor'
  },
  {
    header: 'gross-weight',
    hideColumn: false,
    accessorKey: 'grossWeight'
  },
  {
    header: 'net-weight',
    hideColumn: false,
    accessorKey: 'netWeight'
  },
  {
    header: 'control-code',
    hideColumn: false,
    accessorKey: 'controlCode'
  },
  {
    header: 'sku',
    hideColumn: false,
    accessorKey: 'sku'
  },
  {
    header: 'deletion-indicator',
    hideColumn: false,
    accessorKey: 'deletionIndicator'
  },
  {
    header: 'created-at',
    hideColumn: true,
    accessorKey: 'createdAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'created-by',
    hideColumn: true,
    accessorKey: 'createdBy'
  },
  {
    header: 'updated-at',
    hideColumn: true,
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'updated-by',
    hideColumn: true,
    accessorKey: 'updatedBy'
  },
  {
    header: 'status',
    accessorKey: 'activeStatus',
    cell: (cell) => {
      switch (cell.getValue()) {
        case '0':
          return <Chip color="error" label="In-Active" size="small" variant="light" />;
        case '1':
          return <Chip color="success" label="Active" size="small" variant="light" />;
      }
    }
  }
], ...(isUpdateDeleteAccess ? [
  {
    header: 'action',
    id: "edit",
    cell: (props) => (
      <Grid container className="table-icon-actions-2">
        <VerifyAccess requestedMenu={materialTabMasterKey} requestedFeature={updateKey}>
        <Grid item>
          <EditAction
            {...props}
            onRowEdit={onRowEdit}
          />
        </Grid>
        </VerifyAccess>
        <VerifyAccess requestedMenu={materialTabMasterKey} requestedFeature={deleteKey}>
        <Grid item>
          <DeleteAction
            {...props}
            onRowDelete={onRowDelete} 
            deletePrimaryCustomerMasterStatus={deletePrimaryCustomerMasterStatus}
          />
        </Grid>
        </VerifyAccess>

      </Grid>
    ),
    meta: {
      className: 'cell-center'
    }
  }

]:[])]);

export const reportFileName = "Material Master";

export const initialValues = {
  status: undefined,
}
